// welcome to the shitty temporary file for managing the bbcode/markdown/whatever button

export function TagInfo(name, open, close, summary, icon) {
    return {
        name: name,
        open: open,
        close: close,
        summary: summary,
        icon: icon,
    };
}

const bbTags = [
    new TagInfo('bb-bold', '[b]', '[/b]', 'Bold [b]<text>[/b]', 'fa-solid fa-bold'),
    new TagInfo('bb-italic', '[i]', '[/i]', 'Italic [i]<text>[/i]', 'fa-solid fa-italic'),
    new TagInfo('bb-underline', '[u]', '[/u]', 'Underline [u]<text>[/u]', 'fa-solid fa-underline'),
    new TagInfo('bb-strike', '[s]', '[/s]', 'Strikethrough [s]<text>[/s]', 'fa-solid fa-strikethrough'),
    new TagInfo('bb-link', '[url=]', '[/url]', 'Link [url]<url>[/url] or [url=<url>]<text>[/url]', 'fa-solid fa-link'),
    new TagInfo('bb-image', '[img]', '[/img]', 'Image [img]<url>[/img]', 'fa-solid fa-image'),
    new TagInfo('bb-audio', '[audio]', '[/audio]', 'Audio [audio]<url>[/audio]', 'fa-solid fa-music'),
    new TagInfo('bb-video', '[video]', '[/video]', 'Video [video]<url>[/video]', 'fa-solid fa-video'),
    new TagInfo('bb-code', '[code]', '[/code]', 'Code [code]<code>[/code]', 'fa-solid fa-code'),
    new TagInfo('bb-zalgo', '[zalgo]', '[/zalgo]', 'Zalgo [zalgo]<text>[/zalgo]', 'fa-solid fa-frog'),
];

const tags = {
    'bb': [
        new TagInfo('bb-bold', '[b]', '[/b]', 'Bold [b]<text>[/b]', 'fa-solid fa-bold'),
        new TagInfo('bb-italic', '[i]', '[/i]', 'Italic [i]<text>[/i]', 'fa-solid fa-italic'),
        new TagInfo('bb-underline', '[u]', '[/u]', 'Underline [u]<text>[/u]', 'fa-solid fa-underline'),
        new TagInfo('bb-strike', '[s]', '[/s]', 'Strikethrough [s]<text>[/s]', 'fa-solid fa-strikethrough'),
        new TagInfo('bb-link', '[url=]', '[/url]', 'Link [url]<url>[/url] or [url=<url>]<text>[/url]', 'fa-solid fa-link'),
        new TagInfo('bb-image', '[img]', '[/img]', 'Image [img]<url>[/img]', 'fa-solid fa-image'),
        new TagInfo('bb-audio', '[audio]', '[/audio]', 'Audio [audio]<url>[/audio]', 'fa-solid fa-music'),
        new TagInfo('bb-video', '[video]', '[/video]', 'Video [video]<url>[/video]', 'fa-solid fa-video'),
        new TagInfo('bb-code', '[code]', '[/code]', 'Code [code]<code>[/code]', 'fa-solid fa-code'),
        new TagInfo('bb-zalgo', '[zalgo]', '[/zalgo]', 'Zalgo [zalgo]<text>[/zalgo]', 'fa-solid fa-frog'),
    ],
    'md': [
        new TagInfo('md-bold', '**', '**', 'Bold **<text>**', 'fa-solid fa-bold'),
        new TagInfo('md-italic', '*', '*', 'Italic *<text>* or _<text>_', 'fa-solid fa-italic'),
        new TagInfo('md-underline', '__', '__', 'Underline __<text>__', 'fa-solid fa-underline'),
        new TagInfo('md-strike', '~~', '~~', 'Strikethrough ~~<text>~~', 'fa-solid fa-strikethrough'),
        new TagInfo('md-link', '[](', ')', 'Link [<text>](<url>)', 'fa-solid fa-link'),
        new TagInfo('md-image', '![](', ')', 'Image ![<alt text>](<url>)', 'fa-solid fa-image'),
        new TagInfo('md-audio', '![](', ')', 'Audio ![<alt text>](<url>)', 'fa-solid fa-music'),
        new TagInfo('md-video', '![](', ')', 'Video ![<alt text>](<url>)', 'fa-solid fa-video'),
        new TagInfo('md-code', '```', '```', 'Code `<code>` or ```<code>```', 'fa-solid fa-code'),
    ],
};

export function getTagsFor(parser) {
    return parser in tags ? tags[parser] : [];
};

export function getTagsForPlainText() { return getTagsFor(''); }
export function getTagsForBBcode() { return getTagsFor('bb'); }
export function getTagsForMarkdown() { return getTagsFor('md'); }

export function insertTags(target, tagOpen, tagClose) {
    tagOpen = tagOpen || '';
    tagClose = tagClose || '';

    if(document.selection) {
        target.focus();
        const selected = document.selection.createRange();
        selected.text = tagOpen + selected.text + tagClose;
        target.focus();
    } else if(target.selectionStart || target.selectionStart === 0) {
        const startPos = target.selectionStart,
            endPos = target.selectionEnd,
            scrollTop = target.scrollTop;

        target.value = target.value.substring(0, startPos)
            + tagOpen
            + target.value.substring(startPos, endPos)
            + tagClose
            + target.value.substring(endPos, target.value.length);

        target.focus();
        target.selectionStart = startPos + tagOpen.length;
        target.selectionEnd = endPos + tagOpen.length;
        target.scrollTop = scrollTop;
    } else {
        target.value += tagOpen + tagClose;
        target.focus();
    }
};
